//Please add the language resource
const orderLog = {
  orderNo: 'orderNo',
  orderDate: 'orderDate',
  deliveryDate: 'deliveryDate',
  poNo: 'poNo',
  stoOrSo: 'stoOrSo',
  originNo: 'originNo',
  originName: 'originName',
  originAddr: 'originAddr',
  originWh: 'originWh',
  soldToPaty: 'soldToPaty',
  destNo: 'destNo',
  destName: 'destName',
  destAddr: 'destAddr',
  destProvince: 'destProvince',
  destCity: 'destCity',
  originSloc: 'originSloc',
  groupSoldTo: 'groupSoldTo',
  hqka: 'hqka',
  route: 'route',
  transType: 'transType',
  transWay: 'transWay',
  originWhType: 'originWhType',
  totalQty: 'totalQty',
  totalGrossWeight: 'totalGrossWeight',
  totalVolume: 'totalVolume',
  refRdcNo: 'refRdcNo',
  dealStatus: 'dealStatus',
  dealTime: 'dealTime',
  dealResult: 'dealResult',
  dealCount: 'dealCount',
  createTime: 'createTime',
  detail: {
    itemNo: 'itemNo',
    skuCode: 'skuCode',
    skuDescription: 'skuDescription',
    batch: 'batch',
    qty: 'qty'
  },
  msg: {}
};
export default orderLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/orderLog/lang/orderLog.en.js